import type { AvailabilityVehicle, Vehicle } from '~/contracts';

export const addAvailabilityToVehicles = (
  vehicles: Vehicle[],
  availabilityVehicles: AvailabilityVehicle[]
): Vehicle[] =>
  vehicles.map<Vehicle>(vehicle => {
    const { soonestPickup, soonestDelivery } =
      availabilityVehicles.find(data => data.vehicleId === vehicle.vehicleId) ??
      {};
    const { content: pickupInfo } = soonestPickup ?? {};
    const { content: deliveryInfo } = soonestDelivery ?? {};

    return { ...vehicle, pickupInfo, deliveryInfo };
  });
